import apiDtMood from './dtMoodApiHandler'
import { getDtMoodSession } from './dtmood-session.service'

const getActiveNews = () => {
  const dtMoodSession = getDtMoodSession()
  const clientId = dtMoodSession ? dtMoodSession.clientId : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/news/list/?clientId=${clientId}&type=NEWS`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const getActiveEvents = () => {
  const dtMoodSession = getDtMoodSession()
  const clientId = dtMoodSession ? dtMoodSession.clientId : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/news/list/?clientId=${clientId}&type=EVENT`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const sendInteraction = () => {
  const dtMoodSession = getDtMoodSession()
  const username = dtMoodSession ? dtMoodSession.username : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .put(`/api/news/${username}/`, {})
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { getActiveNews, getActiveEvents, sendInteraction }
